import React, { useState } from 'react';
import DOMPurify from 'dompurify';
import { ValidationErrorsMessages } from '../FormValidation';

export const ConsentAgreement = ({ field, handleChange, formDataEntry, errors } : ControlParameters) : JSX.Element => {

  const [isChecked, setIsChecked] = useState(false);

  if(formDataEntry && formDataEntry.value != isChecked) {
    setIsChecked(formDataEntry.value);
  }

  const handleCheckboxChange = () => {
    handleChange({ target: { name: field["@column"], value: !isChecked } });
    setIsChecked(!isChecked);
  };

  const cleanHtmlString = DOMPurify.sanitize(field.properties.fieldcaption, { ADD_ATTR: ['target'] });

   // Prevent checkbox toggle when clicking on links inside label
   const handleLabelClick = (e) => {
    const target = e.target as HTMLElement;
    if (target.tagName === 'A') {
      e.stopPropagation();
    } else {
      handleCheckboxChange();
    }
  };

  return (
    <div className={`form-group form-checkbox-group machtiging-checkbox-form-group ${field.properties?.fieldcssclass ?? ''}`}>
      <div className="custom-control custom-checkbox">
        <input
          key={field["@guid"]}
          type="checkbox"
          className="custom-control-input"
          name={field["@column"]}
          required={!field["@allowempty"]}
          checked={isChecked}
        />
        <label className="custom-control-label" htmlFor={field["@column"]} onClick={handleLabelClick}>
          <span dangerouslySetInnerHTML={{ __html: cleanHtmlString }}></span>
          {!field["@allowempty"] && (<span> *</span>)}
        </label>
      </div>
      <ValidationErrorsMessages keyGuid={field["@guid"]} errors={errors} />
    </div>
  );
};